export default __webpack_public_path__ + "static/media/center.a42010de.svg";